export default "__VITE_ASSET__Bh_y6DPr__"